import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export type TypeVerifyContractInfoParams = {
  /** 주민등록번호 */
  juminNo: string;
  /** 주소 */
  address: string;
  /** 상세주소 */
  detailAddress: string;
  /** 은행 코드 */
  financialInstitution: string;
  /** 계좌 번호 */
  accountNo: string;
  /** 우편 번호 */
  postCode: string;
};

export type TypeVerifyContractInfoResponse = {
  code: number;
  message: string;
  data: { [key: string]: string }[];
};

/** @description 계약 체결 정보 등록 전, 검증 api 요청에 사용되는 커스텀 훅 */
export const useVerifyContractInfo = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeVerifyContractInfoParams) => {
      const endpoint = '/labor-accounts/privacy-info/verify';
      return axiosInstance.post(endpoint, params);
    },
  });

  const requestVerifyContractInfo = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeVerifyContractInfoParams;
    onSuccess?: (res: TypeVerifyContractInfoResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    return requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestVerifyContractInfo;
};
